export default __webpack_public_path__ + "static/main-197e6ab803cf072e960343d7d0ff5ff5.svg";